import { render, staticRenderFns } from "./SvgPriceTag.vue?vue&type=template&id=a95d1766&"
import script from "./SvgPriceTag.vue?vue&type=script&lang=js&"
export * from "./SvgPriceTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports